import { Grid } from '@material-ui/core';
import React, { useContext } from 'react';
import { VehicleInspections_ReturnToTech } from '../../../Core/Service/vehicleTabChecks';
import AppContext from '../../../App/AppContext';
import { SecondaryButton, TextBox } from '../../../Core/FormInput';
// import { MandatoryField, SecondaryButton } from '../../../../../Core/Controls';
// import { VehicleInspections_ReturnToTech } from '../../../../../Core/Services/InternalUser/Vehicle/vehicleTabChecks';
// import { useToast } from '../../../../../Core/Hooks/useToast';

const ReturnToEngineer = ({ vehicleInspectionID, onClose }) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = React.useState({
        comment: '',
        errors: {}
    });

    const handleInput = (event) => {
        const { name, value } = event.target;
        setState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const validations = () => {
        const { comment } = state;
        let formIsValid = true;
        let errors = {};

        if (!comment.trim()) {
            errors.comment = 'This field is required.';
            formIsValid = false;
        }

        setState((prevState) => ({
            ...prevState,
            errors
        }));

        return formIsValid;
    };

    const handleSubmit = async () => {
        if (!validations()) return;

        const data = {
            comment: state.comment.trim(),
            vehicleInspectionID
        };

        try {
            const res = await VehicleInspections_ReturnToTech(data);
            if (res.success) {
                showToast('Returned to engineer successfully');
                onClose?.(true);
            } else {
                showToast(res.message || 'Something went wrong');
            }
        } catch (err) {
            console.error(err);
            showToast('Failed to return to engineer');
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} className="mandatory-fields">
                <TextBox
                    autoFocus={true}
                    inputLabel="Notes"
                    placeholder="Enter reason for return"
                    name="comment"
                    value={state.comment}
                    onChange={handleInput}
                    multiline
                    rows={5}
                    errors={state.errors?.comment}
                />
            </Grid>
            <Grid item xs={12}>
                <SecondaryButton onClick={handleSubmit}>Return To Engineer</SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default ReturnToEngineer;
